import React, { useState } from "react"
import { Input } from "reactstrap"

import EditPopover, { useDocumentFieldSave } from "./EditPopover"

const EditNotesPopover = ({ open, target, documentId, currentNotes, handleClose, onSaved }) => {
    const [notes, setNotes] = useState(currentNotes || "")
    const { save, saving, error } = useDocumentFieldSave(documentId, onSaved, handleClose)

    return (
        <EditPopover
            open={open}
            target={target}
            label="Notes"
            inputId="idm-document-notes"
            error={error}
            saving={saving}
            canSave={notes !== (currentNotes || "")}
            onClose={handleClose}
            onSave={() => save({ notes }, "Couldn't save these notes.")}
        >
            <Input
                type="textarea"
                id="idm-document-notes"
                className="idm-popover-input"
                rows={3}
                value={notes}
                disabled={saving}
                placeholder="What should the next person know about this document?"
                onChange={(e) => setNotes(e.target.value)}
            />
        </EditPopover>
    )
}

export default EditNotesPopover
